<div class="divbox" fxLayoutAlign="center center">
  <mat-card class="box">
    <div>

      <div class="divtitle">
        <mat-card-title class="clstitle">{{titleUser}}</mat-card-title>
      </div>

      <div>
        <form method="post" class="form" #f="ngForm" (ngSubmit)="f.form.valid && onGuardarItm()">
          <mat-card-content class="mat-elevation-z8">
            <mat-form-field class="full-width">
              <mat-label>{{'user.name' | transloco}}</mat-label>
              <input matInput type="text" name="last_name" placeholder="{{'user.surname' | transloco}}" [(ngModel)]="first_name_Input" required maxlength="64">
              <mat-error>
                {{'user.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'user.surname' | transloco}}</mat-label>
              <input matInput type="text" name="last_name" placeholder="{{'user.surname' | transloco}}" [(ngModel)]="last_name_Input" required maxlength="64">
              <mat-error>
                {{'user.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'user.email' | transloco}}</mat-label>
              <input matInput type="text" name="email" placeholder="{{'user.email' | transloco}}" [(ngModel)]="email_Input" required email maxlength="64">
              <mat-error>
                {{'user.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width" *ngIf="new">
              <mat-label>{{'user.pass' | transloco}}</mat-label>
              <input matInput type="password" name="password" placeholder="{{'user.pass' | transloco}}" [(ngModel)]="password_hash_Input" maxlength="50">
            </mat-form-field>

            <mat-form-field class="full-width" *ngIf="!new">
              <mat-label>{{ 'user.newPass' | transloco }}</mat-label>
              <input matInput type="password" name="password" placeholder="{{ 'user.newPass' | transloco }}" [(ngModel)]="new_password_hash_Input" maxlength="50">
            </mat-form-field>

            <mat-form-field class="full-width" *ngIf="!new && storageService.userId===+id">
              <mat-label>{{ 'user.newPassRepeat' | transloco }}</mat-label>
              <input matInput type="password" name="password_repeat"
                placeholder="{{ 'user.newPassRepeat' | transloco }}" [(ngModel)]="new_password_hash_Input2" maxlength="50" >
            </mat-form-field>
            <mat-error *ngIf="passwordsDoNotMatch">
              {{ 'user.errorMatch' | transloco }}
            </mat-error>

            <mat-form-field class="full-width">
              <mat-label>{{'user.role' | transloco}}</mat-label>
              <mat-select [(value)]="rol_Selected" [formControl]="rolControl" required>
                @for (itemRol of lstRoles; track itemRol) {
                  <mat-option [value]="itemRol.value">{{itemRol.viewValue}}</mat-option>
                }
              </mat-select>
              <mat-error>
                {{'user.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width" *ngIf="storageService.roleId==1">
              <mat-label>{{'user.company' | transloco}}</mat-label>
              <mat-select [(value)]="company_Selected" [formControl]="companyControl" required>
                @for (item of lstCompanies; track item) {
                  <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                }
              </mat-select>
              <mat-error>
                {{'user.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>

            <br>

          </mat-card-content>

          <div style="margin-top: 20px;">
            <div class="button-row" fxLayoutAlign="end">
              <button mat-raised-button color="primary" type="submit">{{'user.save' | transloco}}</button>
              <button mat-raised-button color="warn" *ngIf="!new" type="button" (click)="onEliminarItm()">{{'user.delete' | transloco}}</button>
              <button mat-raised-button color="basic" routerLink="/users">{{'user.cancel' | transloco}}</button>
            </div>
          </div>
        </form>


      </div>

  </div>
  </mat-card>
</div>
